import { AppVersion, createAppVersion } from '@safetyhub/shared';

// Vite에서 주입된 전역 변수 타입 선언
declare const __APP_VERSION__: string;
declare const __BUILD_NUMBER__: string;
declare const __COMMIT_HASH__: string;
declare const __BUILD_DATE__: string;

/**
 * 현재 앱의 버전 정보를 반환합니다.
 * Vite 빌드 시 주입된 값을 사용합니다.
 */
export function getAppVersion(): AppVersion {
  return createAppVersion('mobile', {
    version: __APP_VERSION__,
    buildNumber: __BUILD_NUMBER__,
    commitHash: __COMMIT_HASH__,
    buildDate: __BUILD_DATE__,
  });
}

/**
 * 버전 정보를 JSON 파일로 제공하기 위한 엔드포인트 경로
 */
export const VERSION_ENDPOINT = '/version.json';
